import React from 'react';
import './FullServices.css';
import { Link } from 'react-router-dom';

const FullServices = () => {
    const services = [
        {
            title: "Bought out job work",
            description: "Precision machining support for custom metal components manufactured as per drawings with reliable quality and on-time delivery.",
            image: "https://sakthivel.ascentbw.com/Files/Service/Service1.png",
        },
        {
            title: "Sub contract job work",
            description: "Reliable subcontract machining solutions for batch production with consistent dimensional accuracy and controlled quality standards.",
            image: "https://sakthivel.ascentbw.com/Files/Service/Service2.png",
        },
        {
            title: "Bought out ss job",
            description: "Stainless steel turned and machined components produced for industrial applications with precision finish and durability.",
            image: "https://sakthivel.ascentbw.com/Files/Service/Service3.png"},
        {
            title: "Press fit components",
            description: "Precision press fit components manufactured for secure assembly applications with tight tolerances and repeatable accuracy.",
            image: "https://sakthivel.ascentbw.com/Files/Service/Service4.png",
        },
         {
            title: "Press components",
            description: "Custom press components and formed metal parts produced for industrial assemblies with dependable quality and performance.",
            image: "https://sakthivel.ascentbw.com/Files/Service/Service5.png",
        },
        
    ];

    return (
        <div className="full-services">
            {/* Services Hero */}
            <section className="services-hero">
                <div className="container">
                    <h1 className="fade-in">Additional Services</h1>
                </div>
            </section>

            {/* Services List */}
            <section className="services-list-section section-padding bg-light">
                <div className="container">
                    <h2 className="section-title text-left">Our Additional Manufacturing Services</h2>

                    <div className="fs-services-grid">
                        {services.map((service, idx) => (
                            <div key={idx} className="fs-service-card">
                                <Link to={service.link} className="fs-service-img" style={{ display: 'block' }}>
                                    <img src={service.image} alt={service.title} />
                                </Link>
                                <div className="fs-service-content">
                                    <h3>{service.title}</h3>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Trusted Partner Section */}
            <section className="trusted-partner-section section-padding">
                <div className="container">
                    <div className="partner-split-grid">
                        <div className="partner-text-content">
                            <h2 className="section-title text-left">We Are a Trusted Partner in<br/> Job Work Manufacturing</h2>
                            <p className="description">
                             We are a trusted job work partner for major Tier-2 vendors, delivering quality-focused manufacturing solutions with strong on-time delivery performance.
                            </p>

                            <div className="partner-features">
                                <div className="feature-item">
                                    <span className="dot"></span>
                                    <p>Quality-Focused Job<br/> Work Solutions</p>
                                </div>
                                <div className="feature-item">
                                    <span className="dot"></span>
                                    <p>Trusted Tier-2 Vendor<br/> Support</p>
                                </div>
                                <div className="feature-item">
                                    <span className="dot"></span>
                                    <p>On-Time Delivery<br/> Commitment</p>
                                </div>
                                <div className="feature-item">
                                    <span className="dot"></span>
                                    <p>Press Fit & Fabrication<br/> Expertise</p>
                                </div>
                            </div>

                            <button className="btn-primary mt-40">Learn More About Us</button>
                        </div>
                        <div className="partner-img-frame">
                            <img src="https://sakthivel.ascentbw.com/Files/Service/Services.png" alt="Trusted Partner Facility" />
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="services-cta">
                <div className="container text-center">
                    <h2>Need Flexible Manufacturing Support?</h2>
                    <p>Partner with us for job work, subcontracting, and custom machining solutions tailored to your production needs.</p>
                    <button className="btn-light">Request a Quote</button>
                </div>
            </section>
        </div>
    );
};

export default FullServices;
